type NavBadgeProps = {
  count: number;
};

export default function NavBadge({ count }: NavBadgeProps) {
  if (count <= 0) return null;

  const display = count > 99 ? "99+" : String(count);

  return (
    <span
      className="ml-auto shrink-0 relative z-10 inline-flex items-center justify-center min-w-[18px] h-[18px] px-1.5 rounded-full text-[11px] font-semibold leading-none bg-[#ff6a00]/90 text-white"
      aria-label={`${count} open`}
    >
      {display}
    </span>
  );
}
